






































import { Form, FormItem, Input, Button } from 'element-ui'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'

import FieldError from '@/components/FieldError.vue'

import ErrorEntities from '@/models/error-entities'
import ResetPasswordFormData from '@/models/reset-password-form-data'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    FieldError,
  },
})
export default class ResetPasswordForm extends Vue {
  @Prop() serverErrors!: ErrorEntities
  @Prop() pending!: boolean
  @Ref() readonly resetPasswordForm!: Form

  form: ResetPasswordFormData = {
    password: '',
    passwordConfirmation: '',
    resetPasswordToken: '',
  }

  rules = {
    password: [
      {
        required: true,
        message: 'Please enter your password',
        trigger: 'blur',
      },
      {
        min: 8,
        message: 'Password should be at least 8 characters long',
        trigger: 'blur',
      },
    ],
    passwordConfirmation: [
      {
        required: true,
        message: 'Please enter your password again',
        trigger: 'blur',
      },
      { validator: this.validateConfirmation.bind(this), trigger: 'blur' },
    ],
  }

  get serverError() {
    return this.serverErrors.email && 'Email not found'
  }

  validateConfirmation(
    rule: any,
    value: undefined,
    callback: (errors?: string) => void,
  ) {
    if (value !== this.form.password) {
      callback("Passwords don't match!")
    } else {
      callback()
    }
  }

  submit() {
    this.resetPasswordForm.validate((isValid) => {
      if (isValid) {
        this.$emit('on-reset-password', this.form)
      }
    })
  }
}
